// Use the consolidated evals client from the ai package
// The ai package provides both scoreFeature (for LLM judging) and recordEval (for recording results)
import { EvalsClient } from '@chronosphereio/ai';

// Create browser-specific instance with relative URLs (no API token needed - uses cookies/session)
export const evalClient = new EvalsClient('');

// Re-export the class for consumers who want to create their own instances
export { EvalsClient as EvalClient };
